import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
    return (
        <motion.div
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-70px" }}
            transition={{ duration: 0.9, delay, ease: EASE }}
            className={className}
        >
            {children}
        </motion.div>
    );
}

export function ChapterHeading({ label, title, align = "left", tone = "dark" }) {
    const labelColor = tone === "dark" ? "text-olive" : "text-sand/80";
    const titleColor = tone === "dark" ? "text-ink" : "text-cream";
    return (
        <Reveal className={align === "center" ? "text-center" : ""}>
            <p className={`text-xs font-medium uppercase tracking-[0.28em] md:text-sm ${labelColor}`} data-testid={`chapter-label-${label}`}>
                {label}
            </p>
            <h2 className={`mt-4 font-display text-4xl font-light leading-[1.08] tracking-tight md:text-5xl ${titleColor}`}>
                {title}
            </h2>
        </Reveal>
    );
}
